'use client'

import type React from 'react'
import { useState } from 'react'
import { SessionProvider } from 'next-auth/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

function makeQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 5 * 60 * 1000, // 5 минут
                gcTime: 10 * 60 * 1000, // 10 минут (garbage collection)
                retry: 1,
                refetchOnWindowFocus: false,
            },
        },
    })
}

export function Providers({ children }: { children: React.ReactNode }) {
    const [queryClient] = useState(() => makeQueryClient())

    // SessionProvider без `session` пропа сам подтянет сессию через
    // /api/auth/session на клиенте. Это нужно, чтобы серверный HTML
    // главной/блога не содержал данные конкретного юзера и был
    // безопасно кешируемым (см. SEO-фикс 2026-05).
    return (
        <QueryClientProvider client={queryClient}>
            <SessionProvider>{children}</SessionProvider>
        </QueryClientProvider>
    )
}


